var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActioncentre = function SvgActioncentre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    fillRule: "evenodd",
    d: "M22 7a2 2 0 0 0-2 2v21h28a2 2 0 0 1 2 2v8h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M13 18a2 2 0 0 0-2 2v10h37a2 2 0 0 1 2 2v19h7a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M4 30a2 2 0 0 0-2 2v29a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V32a2 2 0 0 0-2-2zm3 5.5a1.5 1.5 0 0 0 0 3h33a1.5 1.5 0 0 0 0-3zm0 6a1.5 1.5 0 0 0 0 3h28a1.5 1.5 0 0 0 0-3zm36.225 7.297a1.5 1.5 0 0 1 0 2.122l-7.164 7.164a1.5 1.5 0 0 1-2.122 0l-3.858-3.858a1.5 1.5 0 1 1 2.122-2.121L35 54.901l6.104-6.104a1.5 1.5 0 0 1 2.121 0m-25 2.122a1.5 1.5 0 1 0-2.121-2.122l-2.522 2.522-2.521-2.522a1.5 1.5 0 0 0-2.122 2.122l2.522 2.521-2.522 2.522a1.5 1.5 0 1 0 2.122 2.121l2.521-2.521 2.522 2.521a1.5 1.5 0 1 0 2.121-2.121l-2.521-2.522z",
    clipRule: "evenodd"
  })));
};
export default SvgActioncentre;